import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const buttonStyle = css`
  gap: ${theme.spacing(1)};
  display: flex;
  align-items: center;
`;

export const headingStyle = css`
  color: ${theme.colors.primary50};
  line-height: 1;
`;

export const caretStyle = css`
  fill: ${theme.colors.primary50};
  transition: transform 250ms;
`;

export const caretOpenStyle = css`
  transform: rotate(180deg);
`;
